module.exports = __webpack_public_path__ + "static/img/flair.1fe90133.png";